export default __webpack_public_path__ + "static/media/EM1070.34I-39274_-23305_0.27c6a1ae.jpg";